<div id="add-calendar" class="add-calendar add-vacation">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Añadir nuevo calendario</h2>
    </div>
    <form [formGroup]="labourService.fechaForm" role="form">
        <div class="popoup-content">
            <div class="block-looper">
                <mat-label class="label">Fecha</mat-label>
                <mat-form-field appearance="fill">
                    <input formControlName="Fecha" matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-error
                    *ngIf="labourService.fechaForm.get('Fecha').invalid && labourService.fechaForm.get('Fecha').touched && isSunday==false">
                    <span *ngIf="labourService.fechaForm.get('Fecha').hasError ">La fecha es obligatoria</span>
                </mat-error>
                <mat-error *ngIf="isSunday" >
                    <span>El día festivo cae en domingo.</span>
                </mat-error>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="onSubmit()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="onClose()"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>